import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { moveOptions } from './utils';
import type { BookingEventRegistrationMoveFormValues } from '@/types';

import { InputLabel } from '@/components/InputLabel';
import { Field, FieldError } from '@/components/ui/field';

import { bookingDateTimeRange } from '@/helpers';

import { WaveTile } from './WaveTile';

type MoveWaveFieldProps = {
  options: ReturnType<typeof moveOptions>;
};

export const MoveWaveField = (props: MoveWaveFieldProps) => {
  const { options } = props;
  const { t } = useTranslation();
  const { control } = useFormContext<BookingEventRegistrationMoveFormValues>();
  const { field, fieldState } = useController({
    control,
    name: 'event_wave_id',
  });

  return (
    <Field data-invalid={fieldState.invalid}>
      <InputLabel
        label={t('Waves')}
        isInvalid={fieldState.invalid}
        isRequired
      />

      <div className="flex flex-wrap gap-2">
        {options.map(({ wave, isAvailable, errorMessage }) => {
          const waveValue = String(wave.id);

          return (
            <WaveTile
              key={wave.id}
              wave={wave}
              period={bookingDateTimeRange(wave.starts_at, wave.ends_at)}
              isSelected={field.value === waveValue}
              isDisabled={!isAvailable}
              onWaveSelect={() => field.onChange(waveValue)}
            >
              {!!errorMessage && (
                <span className="text-destructive-soft-foreground text-xs">
                  {errorMessage}
                </span>
              )}
            </WaveTile>
          );
        })}
      </div>

      {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
    </Field>
  );
};
